export default __webpack_public_path__ + "static/media/news-16.a7317210.jpeg";